module.exports = __webpack_public_path__ + "static/img/mps.gov.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mps.gov.png
// module id = MXqa
// module chunks = 192